/**
 * API Client for Quran Radio
 * Handles: fetching channels via REST API
 */

import { config } from './config'
import type { Channel, ChannelsResponse } from './types'

export class ApiClient {
  private pollTimer: number | null = null

  // Event callbacks
  onChannels: ((channels: Channel[]) => void) | null = null
  onError: ((error: Error) => void) | null = null

  /**
   * Fetch channels from the API
   */
  async fetchChannels(): Promise<Channel[]> {
    try {
      const url = config.getChannelsUrl()
      console.log('[ApiClient] Fetching channels from:', url)

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data: ChannelsResponse = await response.json()
      const channels = data.channels || []

      console.log('[ApiClient] Received channels:', channels.length)

      if (this.onChannels) {
        this.onChannels(channels)
      }

      return channels
    } catch (error) {
      console.error('[ApiClient] Failed to fetch channels:', error)
      if (this.onError) {
        this.onError(error as Error)
      }
      return []
    }
  }

  /**
   * Start polling for channel updates
   */
  startPolling(): void {
    console.log('[ApiClient] Starting polling...')

    // Initial fetch
    this.fetchChannels()

    // Set up polling for channels (includes now-playing data)
    this.pollTimer = window.setInterval(() => {
      this.fetchChannels()
    }, config.pollInterval)
  }

  /**
   * Stop all polling
   */
  stopPolling(): void {
    console.log('[ApiClient] Stopping polling...')

    if (this.pollTimer) {
      clearInterval(this.pollTimer)
      this.pollTimer = null
    }
  }
}
